import { render, staticRenderFns } from "./Creation.vue?vue&type=template&id=8f6fdd26"
import script from "./Creation.vue?vue&type=script&lang=js"
export * from "./Creation.vue?vue&type=script&lang=js"
import style0 from "./Creation.vue?vue&type=style&index=0&id=8f6fdd26&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports